import FooterBottom from "./footerBottom/FooterBottom";
import data from "../../assets/data/footer/footerDataV3";
import footerLogo1 from "../../assets/images/header-logo.svg";
import socialIconData from "../../assets/data/socialProfile";
import btnArrow from "../../assets/images/blog/white-arrow-icon.png";
import FooterStyleWrapper from "./Footer.style";
import { toast } from "react-toastify";
import { useState } from "react";

const Footer = () => {

  const [email, setEmail] = useState("");
  const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;


  const handleSubscribe = () => {
    if (!email) {
      toast.error("Please enter your email address");
      return;
    }
    if (!emailPattern.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }
    setEmail("");
    toast.success("Subscribed Successfully");
  }


  return (
    <FooterStyleWrapper>
      <div className="top-footer-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="footer_image">
                <a href="# " className="footer-logo">
                  <img src={footerLogo1} alt="footer logo" />
                  <span>CryptoZone</span>
                </a>
                <p>
                  We Are Many Variations Of Passages Available But
                  The Majority Have Suffered Alteration In Some
                  Form By Injected Humour.
                </p>
              </div>
            </div>

            {/* link widgets  */}
            {data?.map((menu, i) => (
              <div key={i} className=" col-sm-6 col-md-3 col-lg-2 link-widgets">
                <div className="footer-menu">
                  <h5 className="menu-title">{menu.widgetName}</h5>
                  <ul className="menu-list">
                    {menu.items?.map((item, i) => (
                      <li key={i}>
                        <a href={item.url}>{item.title}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
            <div className="col-md-6 col-lg-4">
              <div className="footer-menu footer_newsletter">
                <h5 className="menu-title">Subscribe Newsletter</h5>
                <div className="form-box">
                  <input
                    type="text"
                    name="text"
                    placeholder="Email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button onClick={() => handleSubscribe()}>
                    <img src={btnArrow} alt="arrow" />
                  </button>
                </div>

                <div className="bottom_footer_right">
                  <ul>
                    {socialIconData?.map((item, i) => (
                      <li key={i}>
                        <a href={item.url}>
                          {item.thumb ? (
                            <img src={item.thumb} alt="social" />
                          ) : (
                            item.icon
                          )}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* footer bottom  */}
      <FooterBottom />
    </FooterStyleWrapper>
  );
};

export default Footer;
